<template>
    <div class="team-management">
        <!-- 面包屑 -->
        <div class="top_change" @click="goBack">
            <div class="l_where">
                系统设置<span>/</span>团队管理
            </div>
            <div class="r_back" @click="goBack">
                <i class="iconfont icon-fanhui"></i>
            </div>
        </div>

        <!-- 团队列表表格 -->
        <div class="table-container">
            <Table :columns="columns" :data="teamList" stripe>
                <template slot-scope="{ row, index }" slot="index"> 
                    {{ index + 1 }}
                </template>
                <template slot-scope="{ row }" slot="teamName">
                    {{ row.name || '名称' }}
                </template>
                <template slot-scope="{ row }" slot="memberCount">
                    {{ row.team_member.length || 0 }}/{{ row.remain_num || 0 }}
                </template>
                <template slot-scope="{ row }" slot="createTime">
                    {{ row.created_at || '-' }}
                </template>
                <template slot-scope="{ row }" slot="expireTime">
                    {{ row.start_date || '-' }} ~ {{ row.expires_date || '-' }}
                </template>
                <template slot-scope="{ row }" slot="action">
                    <div style="display: flex;gap: 10px;">
                        <div class="table-btn blue" @click="viewTeamDetail(row)">详情</div>
                        <div class="table-btn edit" @click="editTeamName(row)">修改</div>
                    </div>
                    
                </template>
            </Table>

            <!-- 分页 -->
            <div class="pagination-container">
                
            <Page :total="storePrams.total" :current="storePrams.page" style="text-align:right" show-elevator show-total
                @on-change="handlePageChange" :page-size="storePrams.limit" />
            </div>
        </div>

        <!-- 修改团队名称对话框 -->
        <Modal v-model="editNameModal" title="修改团队名称" @on-ok="confirmEditName" @on-cancel="cancelEditName">
            <Form :model="editNameForm" label-position="right" :label-width="100">
                <FormItem label="团队名称">
                    <Input v-model="editNameForm.name" placeholder="请输入" />
                </FormItem>
            </Form>
            <div slot="footer">
                <Button @click="cancelEditName">取消</Button>
                <Button type="primary" @click="confirmEditName">确定</Button>
            </div>
        </Modal>

        <!-- 团队成员详情对话框 -->
        <Modal v-model="memberModal" :title="`团队成员 (${currentTeamMemberCount}/${currentTeamMaxMember})`" width="700"
            footer-hide>
            <div class="member-modal-content">
                <div class="table-btn blue" @click="showAddMemberModal">添加成员</div>
                <div style="max-height: 500px;overflow-y: auto;"> 
                    <Table :columns="memberColumns" :data="memberList" stripe style="margin-top: 16px;">
                    <template slot-scope="{ row }" slot="memberName">
                        {{ row.name || '成员名称' }}
                    </template>
                    <template slot-scope="{ row }" slot="phone">
                        {{ row.phone || '-' }}
                    </template>
                    <template slot-scope="{ row }" slot="joinTime">
                        {{ row.created_at || '-' }}
                    </template>
                    <template slot-scope="{ row }" slot="action">
                        <div class="table-btn edit" @click="editMemberName(row)">修改</div> 
                    </template>
                </Table>
                </div>
            </div>
        </Modal>

        <!-- 添加成员对话框 -->
        <Modal v-model="addMemberModal" title="添加成员" @on-ok="confirmAddMember" @on-cancel="cancelAddMember">
            <Form :model="addMemberForm" label-position="right" :label-width="100">
                <FormItem label="成员名称">
                    <Input v-model="addMemberForm.name" placeholder="请输入" />
                </FormItem>
                <FormItem label="手机号">
                    <Input v-model="addMemberForm.phone" placeholder="请输入" />
                </FormItem>
            </Form>
            <div slot="footer">
                <Button @click="cancelAddMember">取消</Button>
                <Button type="primary" @click="confirmAddMember">确定</Button>
            </div>
        </Modal>

        <!-- 修改成员名称对话框 -->
        <Modal v-model="editMemberModal" title="修改成员名称" @on-ok="confirmEditMember" @on-cancel="cancelEditMember">
            <Form :model="editMemberForm" label-position="right" :label-width="100">
                <FormItem label="成员名称">
                    <Input v-model="editMemberForm.name" placeholder="请输入" />
                </FormItem>
            </Form>
            <div slot="footer">
                <Button @click="cancelEditMember">取消</Button>
                <Button type="primary" @click="confirmEditMember">确定</Button>
            </div>
        </Modal>
    </div>
</template>

<script>
import {
    get_user_teamlist,
    get_member_list,
    add_user,
    up_name,
    up_member_name
} from '@/api/tang'

export default {
    name: 'TeamManagement',
    data() {
        return {
            // 团队列表
            teamList: [], 
            storePrams: {
                limit: 20,
                page: 1,
                total: 0,
            },
            total: 0,

            // 表格列配置
            columns: [
                {
                    title: '#',
                    slot: 'index',
                    width: 80,
                    align: 'center'
                },
                {
                    title: '团队名称',
                    slot: 'teamName',
                    align: 'center'
                },
                {
                    title: '团队人数',
                    slot: 'memberCount',
                    align: 'center'
                },
                {
                    title: '创建时间',
                    slot: 'createTime',
                    align: 'center'
                },
                {
                    title: '到期时间',
                    slot: 'expireTime',
                    align: 'center'
                },
                {
                    title: '操作',
                    slot: 'action',
                    align: 'center',
                    width: 180
                }
            ],

            // 修改团队名称
            editNameModal: false,
            editNameForm: {
                team_id: '',
                name: ''
            },

            // 团队成员
            memberModal: false,
            memberList: [],
            currentTeamId: '',
            currentTeamMemberCount: 0,
            currentTeamMaxMember: 0,
            memberColumns: [
                {
                    title: '成员名称',
                    slot: 'memberName',
                    align: 'center'
                },
                {
                    title: '手机号',
                    slot: 'phone',
                    align: 'center'
                },
                {
                    title: '时间',
                    slot: 'joinTime',
                    align: 'center'
                },
                {
                    title: '操作',
                    slot: 'action',
                    align: 'center',
                    width: 120
                }
            ],

            // 添加成员
            addMemberModal: false,
            addMemberForm: {
                team_id: '',
                name: '',
                phone: ''
            },

            // 修改成员名称
            editMemberModal: false,
            editMemberForm: {
                id: '',
                name: ''
            }
        }
    },

    mounted() {
        this.getTeamList()
    },

    methods: {
        // 获取团队列表
        getTeamList() {
            get_user_teamlist(this.storePrams).then(res => {
                this.teamList = res.data.data || []
                this.storePrams.total = res.data.total || 0
            }).catch(res => {
                this.$Message.error(res.msg)
            })
        },

        // 分页切换
        handlePageChange(page) {
            this.page = page
            this.getTeamList()
        },

        // 查看团队详情（成员列表）
        viewTeamDetail(row) {
            this.currentTeamId = row.id || row.team_id
            this.currentTeamMemberCount = row.team_member.length || 0
            this.currentTeamMaxMember = row.remain_num || 0
            this.memberModal = true
            this.getMemberList()
        },

        // 获取成员列表
        getMemberList() {
            get_member_list({
                    team_id: this.currentTeamId,
                    page: 1,
                    limit: 999999
                }).then(res => { 
                    this.memberList = res.data.data || [] 
                }).catch(res => {
                    this.$Message.error(res.msg)
                })
        },
        
        goBack() {
            this.$emit('goBack')
        },

        // 显示添加成员对话框
        showAddMemberModal() {
            this.addMemberForm = {
                team_id: this.currentTeamId,
                name: '',
                phone: ''
            }
            this.addMemberModal = true
        },

        // 确认添加成员
        confirmAddMember() {
            if (!this.addMemberForm.name || !this.addMemberForm.phone) {
                this.$Message.warning('请填写完整信息')
                return
            }
            add_user(this.addMemberForm).then(res => {
                if (res.code === 200) {
                    this.$Message.success('添加成员成功')
                    this.addMemberModal = false
                    this.getMemberList()
                    this.getTeamList()
                } else {
                    this.$Message.error(res.msg || '添加成员失败')
                }
            }).catch(res => {
                this.$Message.error(res.msg)
            }) 
        },

        // 取消添加成员
        cancelAddMember() {
            this.addMemberModal = false
            this.addMemberForm = {
                team_id: '',
                name: '',
                phone: ''
            }
        },

        // 修改团队名称
        editTeamName(row) {
            this.editNameForm = {
                team_id: row.id || row.team_id,
                name: row.name || ''
            }
            this.editNameModal = true
        },

        // 确认修改团队名称
        confirmEditName() {
            if (!this.editNameForm.name) {
                this.$Message.warning('请输入团队名称')
                return
            }
                up_name(this.editNameForm).then(res => {
                    if (res.code === 200) {
                        this.$Message.success('修改成功')
                        this.editNameModal = false
                        this.getTeamList()
                    } else {
                        this.$Message.error(res.msg || '修改失败')
                    }
                }).catch(res => {
                    this.$Message.error(res.msg)
                })
               
        },

        // 取消修改团队名称
        cancelEditName() {
            this.editNameModal = false
            this.editNameForm = {
                team_id: '',
                name: ''
            }
        },

        // 修改成员名称
        editMemberName(row) {
            this.editMemberForm = {
                id: row.id,
                name: row.name || ''
            }
            this.editMemberModal = true
        },

        // 确认修改成员名称
        confirmEditMember() {
            if (!this.editMemberForm.name) {
                this.$Message.warning('请输入成员名称')
                return
            }
            let data = {
                member_id: this.editMemberForm.id,
                name: this.editMemberForm.name
            }
            up_member_name(data).then(res => {
                if (res.code === 200) {
                    this.$Message.success(res.msg || '修改成功')
                    this.editMemberModal = false
                    this.getMemberList()
                } else {
                    this.$Message.error(res.msg || '修改失败')
                }
            }).catch(res => {
                this.$Message.error(res.msg)
            })
        },

        // 取消修改成员名称
        cancelEditMember() {
            this.editMemberModal = false
            this.editMemberForm = {
                id: '',
                name: ''
            }
        }
    }
}
</script>

<style scoped  lang="scss">  
.breadcrumb {
    background: white;
    padding: 16px 24px;
    margin-bottom: 16px;
    border-radius: 4px;
    font-size: 14px;
    color: #333;
}

.breadcrumb .separator {
    margin: 0 8px;
    color: #999;
}

.table-container {
    background: white;
    padding: 24px;
    border-radius: 8px;
    margin-top: 20px;

}

.pagination-container {
    margin-top: 20px;
    text-align: right;
}

.member-modal-content {
    padding: 10px 0;
}

.top_change {
        width: 100%;
        cursor: pointer;
        background: #FFFFFF;
        border-radius: 8px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0px 30px;
        box-sizing: border-box;
        height: 60px;

        .l_where {
            font-size: 18px;
            font-family: PingFang SC;
            font-weight: bold;
            color: #1B2742;

            span {
                color: #4877E8;
            }
        }

        .r_back {
            width: 200px;
            cursor: pointer;
            text-align: end;

            .iconfont {
                font-size: 26px;
                cursor: pointer;

                &:hover {
                    color: #4877E8;
                }
            }
        }
    }
</style>